import { SupplierShape } from './supplier-types';
import csv2json from 'csvtojson';
import { handlePreprocessConversions } from '../../helpers/handlePreprocessConversions';
import { MONGO_OLD_CATALOG_RULESET } from './mongooldcatalog/catalog';
import { TRule } from '../typings';

export const MONGO_OLD_CATALOG_SUPPLIER: SupplierShape = {
  weight: 5,
  override: true,
  ruleset: MONGO_OLD_CATALOG_RULESET,
  pricelistRuleset: [] as TRule[],
  stockRuleset: [] as TRule[],
  canSaveWithoutNecessaryFields: true,
  canSaveWithoutEan: true,
  preprocessKeys: {
    width: {
      ',': '.',
      '"': '',
      x: '',
      X: '',
    },
    color: {
      '�': 'a',
      'ÔøΩ': 'a',
    },
    Brand: {
      'A-PLUS': 'APLUS',
      'AANHANGER STAAL': 'AANHANGER',
    },
  },
  hardCodes: { 1: { product: {}, model: {} } },
  stockDefaults: { model: {}, product: {} },
  pricelistDefaults: { model: {}, product: {} },
  catalogDefaults: {
    product: {
      productName2: '',
      dirtyFields: '{}',
      dataSource: 'MONGO OLD CATALOG',
    },
    model: {
      dirtyFields: '{}',
      dataSource: 'MONGO OLD CATALOG',
      // sidewall: 'WW',
    },
  },

  async preprocessPricelist(file: string) {
    const json = await csv2json({ delimiter: ',' }).fromString(file);

    return json;
  },
  async preprocessStockList(file: string) {
    const json = await csv2json({ delimiter: ',' }).fromString(file);

    return json;
  },
  async preprocessCatalog(file: string) {
    const json = await csv2json({ delimiter: ',' }).fromString(file);

    // console.log(`** Attempting to import ${json.length} lines.`);

    const filtered = json.filter((item) => !item['PCD'].includes('000') && !item['PCD'].includes('/'));
    return handlePreprocessConversions(filtered, this.preprocessKeys);
  },
};
